import React from 'react';
import {useSelector} from "react-redux";
import {hoveredCartoFeaturesSelector, mouseHoverCoordsSelector, selectedGeographySelector} from "../Redux/selectors";
import {LocationTitleForCommunitySummary} from "./utilsJSX";
import {MapHoverTooltipLayer} from "./MapHoverTooltipLayer";
import {isAttrLayer} from "../utilsData";

const getTooltipPos = ({x, y}) => {
  const above = window && window.innerHeight && y && y > (window.innerHeight / 3)
  const left = window && window.innerWidth && x && x > (window.innerWidth / 2)
  
  const xPos = left ?
    'calc(-115% + ' + x + 'px)' :
    'calc(15% + ' + x + 'px)';
  const yPos = above ?
    'calc(-133% + ' + y + 'px)' :
    'calc(33% + ' + y + 'px)'
  return {
    xPos,
    yPos,
  }
}


const Tooltip = () => {
  const selectedGeography = useSelector(selectedGeographySelector)
  const hoveredCartoFeatures = useSelector(hoveredCartoFeaturesSelector)
  const {x, y} = useSelector(mouseHoverCoordsSelector)
  
  if (!x || !y) return null
  const {xPos, yPos} = getTooltipPos({x, y})
  
  const attrLayer = hoveredCartoFeatures.find(({layer: {id}}) => isAttrLayer(id))
  const nonAttrLayerCartoFeatures = hoveredCartoFeatures.filter(({layer: {id}}) => !isAttrLayer(id))
  
  return (
    <div
      className="tooltip container-with-a-shadow"
      style={{
        transform: `translate(${xPos}, ${yPos})`,
      }}
    >
      {attrLayer &&
      <div className="tooltip-attribute-header big-bold-header-text">
        {LocationTitleForCommunitySummary(selectedGeography, attrLayer.properties, false)}
      </div>
      }
  
      {nonAttrLayerCartoFeatures.map(feature =>(<MapHoverTooltipLayer key={feature.layer.id} feature={feature}/>))}
    </div>
  )
}

export default Tooltip;
